// extracted by mini-css-extract-plugin
export var sectionHeader = "storyFirstSection-module--sectionHeader--0Y-2O";
export var sectionHeaderInner = "storyFirstSection-module--sectionHeaderInner--ap8jr";
export var sectionHeaderLogo = "storyFirstSection-module--sectionHeaderLogo--tfF0k";
export var story__imageOne = "storyFirstSection-module--story__imageOne--6xt4H";
export var story__imageTwo = "storyFirstSection-module--story__imageTwo--sXP8+";